import React from "react";
import { Route, Switch } from "react-router-dom";
import { segmentsRoutes } from "./routes";

const SpacesRouter = () => {
  return (
    <Switch>
      {segmentsRoutes.map((route, index) => (
        <Route key={index} exact={route.exact} path={route.path}>
          <route.main />
        </Route>
      ))}
    </Switch>
  );
};

export default SpacesRouter;
